<template>
  <div>
    <report-header @generate="load" @filterChanged="filterChanged"
      @onChangedDateStart="onChangedDateStart" @onChangedDateEnd="onChangedDateEnd" @onChangedGroup="onChangedGroup"
      :filterOptions="filterOptions" :isGenerateDisabled="isGenerateDisabled" @paginationChanged="paginationChanged"
      @limitChanged="limitChanged"
      @download="download"
      @onChangeAccsGroup="onChangeAccsGroup"/>

    <basic-table
      @Filtred="Filtred"
      :items="general"
      :fields="generalFields"
      :filter="filter"
      :per-page="perPage"
      :current-page="currentPage"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
  </div>
</template>

<script>
import download from '@/utils/downloadFile'
export default {
  props: {
    userId: 0
  },
  data () {
    return {
      getStore: {
        numDateEnd: 0,
        numDateStart: 0,
        userId: 0,
        group_id: 0,
        accs_group_id: 0,
        account_id: 0,
        accounting_period_id: 0,
        limit: 500,
        download: 0
      },
      general: [],
      generalFields: [
        {key: 'account_id', label: this.$i18n.t('Account ID'), sortable: true},
        {key: 'login', label: this.$i18n.t('Login'), sortable: true},
        {key: 'full_name', label: this.$i18n.t('FullName'), sortable: true},
        {key: 'incoming_rest',
          label: this.$i18n.t('Initial balance'),
          sortable: true,
          formatter: (val, key, item) => {
            return val.toFixed(2)
          }},
        {key: 'once',
          label: this.$i18n.t('One-time services'),
          sortable: true,
          formatter: (val, key, item) => {
            return val.toFixed(2)
          }},
        {key: 'periodic',
          label: this.$i18n.t('Periodic services'),
          sortable: true,
          formatter: (val, key, item) => {
            return val.toFixed(2)
          }},
        {key: 'ip_traffic',
          label: this.$i18n.t('IP traffic'),
          sortable: true,
          formatter: (val, key, item) => {
            return val.toFixed(2)
          }},
        {key: 'hotspot',
          label: this.$i18n.t('Hotspot services charges'),
          sortable: true,
          formatter: (val, key, item) => {
            return val.toFixed(2)
          }},
        {key: 'dialup',
          label: this.$i18n.t('Dial-up service charges'),
          sortable: true,
          formatter: (val, key, item) => {
            return val.toFixed(2)
          }},
        {key: 'telephony',
          label: this.$i18n.t('Telephony2'),
          sortable: true,
          formatter: (val, key, item) => {
            return val.toFixed(2)
          }},
        {key: 'iptv',
          label: this.$i18n.t('IPTV service charges'),
          sortable: true,
          formatter: (val, key, item) => {
            return val.toFixed(2)
          }},
        {key: 'vod',
          label: this.$i18n.t('VOD service charges'),
          sortable: true,
          formatter: (val, key, item) => {
            return val.toFixed(2)
          }},
        {key: 'other',
          label: this.$i18n.t('Other charges report'),
          sortable: true,
          formatter: (val, key, item) => {
            return val.toFixed(2)
          }},
        {key: 'tax',
          label: this.$i18n.t('Tax sum'),
          sortable: true,
          formatter: (val, key, item) => {
            return val.toFixed(2)
          }},
        {key: 'sum_with_tax',
          label: this.$i18n.t('Total (incl. taxes)'),
          sortable: true,
          formatter: (val, key, item) => {
            return val.toFixed(2)
          }},
        {key: 'payments',
          label: this.$i18n.t('Payments'),
          sortable: true,
          formatter: (val, key, item) => {
            return val.toFixed(2)
          }},
        {key: 'outgoing_rest',
          label: this.$i18n.t('Closing balance'),
          sortable: true,
          formatter: (val, key, item) => {
            return val.toFixed(2)
          }}
      ],
      isGenerateDisabled: false,
      selectGroup: 0,
      selectAccsGroup: 0,
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      dateStart: this.$root.setDataWithSelectedTZ().toDate(),
      dateEnd: this.$root.setDataWithSelectedTZ().toDate(),
      filterOptions: {
        isFilterGroup: true,
        isFilterAccsGroup: true,
        isFilterTypeTraffic: false,
        isFilterTypeDocuments: false,
        isFilterTypeUsers: false,
        isFilterCollector: false,
        isDownloadable: true,
        hasLimitRows: true
      }
    }
  },
  methods: {
    Filtred (items) {
      this.totalRows = items.length
    },
    async load (isGenerate = true) {
      this.isGenerateDisabled = true
      let numDateEnd = Number(this.dateEnd) / 1000
      if (numDateEnd > 2147483647) numDateEnd = 2147483647
      let numDateStart = Number(this.dateStart) / 1000
      if (numDateStart > 2147483647) numDateStart = 2147483647
      this.getStore.numDateEnd = numDateEnd
      this.getStore.numDateStart = numDateStart
      if (!this.userId) {
        this.getStore.group_id = this.selectGroup
        this.getStore.accs_group_id = this.selectAccsGroup
      } else {
        this.getStore.userId = this.userId
      }
      await this.$store.dispatch('Reports/GET_GENERAL', this.getStore).then(response => {
        if (isGenerate) {
          this.general = this.$store.getters['Reports/GENERAL']
        } else {
          download(this.$store.getters['Reports/GENERAL'], 'report_services_general.csv', 'text/csv')
        }
        this.loadDone()
      })
      this.totalRows = isGenerate ? this.general.length : 0
      this.$emit('input', this.totalRows)
    },
    download () {
      this.getStore.download = 1
      this.load(false)
      this.$store.dispatch('Reports/CLEAR_GENERAL')
      this.getStore.download = 0
      this.general = []
    },
    limitChanged (limit) {
      this.getStore.limit = limit
    },
    onChangedDateStart (value) {
      this.dateStart = value
    },
    onChangedDateEnd (value) {
      this.dateEnd = value
    },
    onChangedGroup (value) {
      this.selectGroup = (value)
    },
    onChangeAccsGroup (value) {
      this.selectAccsGroup = value
    },
    filterChanged (value) {
      this.filter = value
    },
    loadDone () {
      this.isGenerateDisabled = false
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  mounted () {
    this.loadDone()
    if (this.userId) {
      this.filterOptions.isFilterGroup = false
      this.filterOptions.isFilterAccsGroup = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/reports/services/general/main.vue